<template>
	<v-row justify="center">
		<v-dialog v-model="ui.dialog" persistent max-width="600">
			<v-card class="pa-4">
				<v-card-title>
					Vincular artículo
				</v-card-title>
				<v-card-text class="pb-0">
					<v-form
						ref="form"
						v-model="ui.valid"
						lazy-validation
						@submit.prevent="store()"
					>
						<v-row>
							<v-col cols="12" class="pb-0">
								<v-overflow-btn
									dense
									outlined
									editable
									clearable
									label="Artículo"
									autocomplete="off"
									:rules="[v.required]"
									:items="Articles"
									v-model="layout.article_id"
								>
								</v-overflow-btn>
							</v-col>
						</v-row>
					</v-form>
				</v-card-text>
				<v-card-actions class="d-flex justify-end">
					<v-btn
						text
						color="primary"
						:disabled="ui.storing"
						@click="ui.dialog = false"
					>
						cancelar
					</v-btn>
					<v-btn
						color="primary"
						@click="store()"
						:loading="ui.storing"
						:disabled="!ui.valid"
					>
						enviar
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</v-row>
</template>

<script>
import axios from "axios";
import { V } from "@/main";
import { EventBus } from "@/main";
import { mapGetters } from "vuex";

export default {
	name: "ArticlePriceListCreate",

	data() {
		return {
			layout: { customer_id: null },

			v: V,

			ui: {
				valid: true,
				dialog: false,
				storing: false,
			},
		};
	},

	created() {
		EventBus.$on("PriceListArticleCreate", () => {
			this.ui.dialog = true;
		});

		this.$store.dispatch("getArticles");
	},

	computed: {
		...mapGetters(["getArticles"]),

		Articles() {
			this.getArticles.map((article) => {
				return {
					text: article.name,
					value: article.id,
				};
			});
		},
	},
};
</script>

<style lang="css" scoped></style>
